import { gql } from 'graphql-request';

export const LOGIN_MUTATION = gql`
  mutation($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      token
    }
  }
`;

export const RESEND_CONFIRM_EMAIL_MUTATION = gql`
  mutation($email: String!) {
    resendConfirmEmail(email: $email)
  }
`;

export const CONFIRM_EMAIL_MUTATION = gql`
  mutation($token: String!, $password: String!) {
    confirmEmail(token: $token, password: $password)
  }
`;

export const RESET_PASSWORD_REQUEST_MUTATION = gql`
  mutation($email: String!) {
    requestResetPassword(email: $email)
  }
`;

export const RESET_PASSWORD_MUTATION = gql`
  mutation($token: String!, $password: String!) {
    resetPassword(token: $token, password: $password)
  }
`;

export const registerMutation = gql`
  mutation($email: String!, $role: Role) {
    register(email: $email, role: $role) {
      email
    }
  }
`;

export const resendConfirmEmailMutation = gql`
  mutation($email: String!) {
    resendConfirmEmail(email: $email)
  }
`;

export const deleteRegularUserMutation = gql`
  mutation($id: Uuid!) {
    deleteRegularUser(id: $id) {
      email
    }
  }
`;
